import api from '../configs/api';
import helper from '../helpers/api';

const resource = 'tip';

export default {
  ...helper(resource),
  dismiss: id => api.post(`${resource}/${id}/dismiss`),
};
